const LOOPBACK_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

const parse = (value: string): URL | null => {
    try {
        return new URL(value);
    } catch {
        return null;
    }
};

const isAllowedServerUrl = (serverUrl: string, apiUrl: string, allowLoopbackHttp: boolean): boolean => {
    const target = parse(serverUrl);
    const api = parse(apiUrl);
    if (!target || !api || target.username || target.password || target.origin !== api.origin) {
        return false;
    }
    return target.protocol === 'https:'
        || (allowLoopbackHttp && target.protocol === 'http:' && LOOPBACK_HOSTS.includes(target.hostname));
};

export default isAllowedServerUrl;
